import { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Grid, Tooltip, Typography } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
import { useNavigate } from 'react-router-dom'

const DocumentPanel = ({ fileUri, height = 800, width = 1000 }) => {
  const navigate = useNavigate()
  const [loadError, setLoadError] = useState(false)

  const onClose = () => {
    navigate('/reports/documents')
  }

  const baseUri = fileUri?.split('#')[0] || ''
  const openPdfConfig = '#navpane=0&page=1&view=FitH'
  const src = `${baseUri}${openPdfConfig}`

  console.log('DocumentPanel render -> src:', src)

  return (
    <Box>
      {/* Header: Close button */}
      <Grid container justifyContent="flex-end" sx={{ mb: 1 }}>
        <Tooltip title="Close document preview">
          <IconButton
            onClick={onClose}
            sx={{
              width: 32,
              height: 32,
              background: 'transparent',
              borderRadius: '50%',
              transition: '0.2s ease-out',
              '&:hover': { opacity: 0.8 },
            }}>
            <CancelOutlinedIcon color="error" sx={{ width: 26, height: 26 }} />
          </IconButton>
        </Tooltip>
      </Grid>

      <Box
        sx={{
          border: '1px solid #ccc',
          borderRadius: 2,
          overflow: 'hidden',
          position: 'relative',
          backgroundColor: '#fafafa',
        }}>
        {!loadError ? (
          <iframe
            src={src}
            title="Document Preview"
            style={{ border: 'none' }}
            height={`${height}px`}
            width={`${width}px`}
            onError={() => setLoadError(true)}/>
        ) : (
          <Box
            sx={{
              height: `${height}px`,
              width: `${width}px`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              p: 3,
            }}>
            <Typography variant="h6" color="error" gutterBottom>
               Unable to load PDF preview
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Click below to download or view the file directly.
            </Typography>
            <Typography sx={{ mt: 2 }}>
              <a
                href={fileUri}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: '#1976d2',
                  fontWeight: 500,
                }}>
                Open Document in New Tab
              </a>
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  )
}

DocumentPanel.propTypes = {
  fileUri: PropTypes.string.isRequired,
  height: PropTypes.number,
  width: PropTypes.number,
}

export default DocumentPanel
